// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"157b5791","395":"5f36dc3f","422":"685f5ec9","441":"de87fbd1","495":"80bf86c6","690":"a4b982e4","854":"d6f31e8a"}[chunkId] + ".chunk.js";
};